import { predefinedFacetsMap } from "./predefined_facets_map";

const PredefinedFacetsBuilder = function () {
  let params = {};

  return Object.freeze({
    applicationID: function (applicationID) {
      params[predefinedFacetsMap.ApplicationID] = applicationID;
      return this;
    },

    appVersion: function (appVersion) {
      params[predefinedFacetsMap.AppVersion] = appVersion;
      return this;
    },

    bookingBatch: function (bookingBatch) {
      params[predefinedFacetsMap.BookingBatch] = bookingBatch;
      return this;
    },

    bookingCode: function (bookingCode) {
      params[predefinedFacetsMap.BookingCode] = bookingCode;
      return this;
    },

    city: function (city) {
      params[predefinedFacetsMap.City] = city;
      return this;
    },

    carrier: function (carrier) {
      params[predefinedFacetsMap.Carrier] = carrier;
      return this;
    },

    clientIP: function (clientIP) {
      params[predefinedFacetsMap.ClientIP] = clientIP;
      return this;
    },

    country: function (country) {
      params[predefinedFacetsMap.Country] = country;
      return this;
    },

    driver: function (driver) {
      params[predefinedFacetsMap.Driver] = driver;
      return this;
    },

    deviceLanguage: function (deviceLanguage) {
      params[predefinedFacetsMap.DeviceLanguage] = deviceLanguage;
      return this;
    },

    deviceLocale: function (deviceLocale) {
      params[predefinedFacetsMap.DeviceLocale] = deviceLocale;
      return this;
    },

    domain: function (domain) {
      params[predefinedFacetsMap.Domain] = domain;
      return this;
    },

    device: function (device) {
      params[predefinedFacetsMap.Device] = device;
      return this;
    },

    deviceID: function (deviceID) {
      params[predefinedFacetsMap.DeviceID] = deviceID;
      return this;
    },

    deviceBrand: function (deviceBrand) {
      params[predefinedFacetsMap.DeviceBrand] = deviceBrand;
      return this;
    },

    deviceModel: function (deviceModel) {
      params[predefinedFacetsMap.DeviceModel] = deviceModel;
      return this;
    },

    deviceRAM: function (deviceRAM) {
      params[predefinedFacetsMap.DeviceRAM] = deviceRAM;
      return this;
    },

    deviceScreenFactor: function (deviceScreenFactor) {
      params[predefinedFacetsMap.DeviceScreenFactor] = deviceScreenFactor;
      return this;
    },

    error: function (error) {
      params[predefinedFacetsMap.Error] = error;
      return this;
    },

    experiment: function (experiment) {
      params[predefinedFacetsMap.Experiment] = experiment;
      return this;
    },

    foodBusinessType: function (foodBusinessType) {
      params[predefinedFacetsMap.FoodBusinessType] = foodBusinessType;
      return this;
    },

    foodOrderType: function (foodOrderType) {
      params[predefinedFacetsMap.FoodOrderType] = foodOrderType;
      return this;
    },

    host: function (host) {
      params[predefinedFacetsMap.Host] = host;
      return this;
    },

    iD: function (iD) {
      params[predefinedFacetsMap.ID] = iD;
      return this;
    },

    iPAddress: function (iPAddress) {
      params[predefinedFacetsMap.IPAddress] = iPAddress;
      return this;
    },

    languageCode: function (languageCode) {
      params[predefinedFacetsMap.LanguageCode] = languageCode;
      return this;
    },

    locationGranted: function (locationGranted) {
      params[predefinedFacetsMap.LocationGranted] = locationGranted;
      return this;
    },

    locale: function (locale) {
      params[predefinedFacetsMap.Locale] = locale;
      return this;
    },

    location: function (location) {
      params[predefinedFacetsMap.Location] = location;
      return this;
    },

    log: function (log) {
      params[predefinedFacetsMap.Log] = log;
      return this;
    },

    logLevel: function (logLevel) {
      params[predefinedFacetsMap.LogLevel] = logLevel;
      return this;
    },

    taxiVehicle: function (taxiVehicle) {
      params[predefinedFacetsMap.TaxiVehicle] = taxiVehicle;
      return this;
    },

    vehiclePlate: function (vehiclePlate) {
      params[predefinedFacetsMap.VehiclePlate] = vehiclePlate;
      return this;
    },

    merchant: function (merchant) {
      params[predefinedFacetsMap.Merchant] = merchant;
      return this;
    },

    mexUser: function (mexUser) {
      params[predefinedFacetsMap.MexUser] = mexUser;
      return this;
    },

    mexStore: function (mexStore) {
      params[predefinedFacetsMap.MexStore] = mexStore;
      return this;
    },

    mobileCountryCode: function (mobileCountryCode) {
      params[predefinedFacetsMap.MobileCountryCode] = mobileCountryCode;
      return this;
    },

    network: function (network) {
      params[predefinedFacetsMap.Network] = network;
      return this;
    },

    networkType: function (networkType) {
      params[predefinedFacetsMap.NetworkType] = networkType;
      return this;
    },

    osType: function (osType) {
      params[predefinedFacetsMap.OsType] = osType;
      return this;
    },

    osVersion: function (osVersion) {
      params[predefinedFacetsMap.OsVersion] = osVersion;
      return this;
    },

    passenger: function (passenger) {
      params[predefinedFacetsMap.Passenger] = passenger;
      return this;
    },

    patronusID: function (patronusID) {
      params[predefinedFacetsMap.PatronusID] = patronusID;
      return this;
    },

    publicUserID: function (publicUserID) {
      params[predefinedFacetsMap.PublicUserID] = publicUserID;
      return this;
    },

    serviceUserID: function (serviceUserID) {
      params[predefinedFacetsMap.ServiceUserID] = serviceUserID;
      return this;
    },

    prefix: function (prefix) {
      params[predefinedFacetsMap.Prefix] = prefix;
      return this;
    },

    request: function (request) {
      params[predefinedFacetsMap.Request] = request;
      return this;
    },

    region: function (region) {
      params[predefinedFacetsMap.Region] = region;
      return this;
    },

    screenResolution: function (screenResolution) {
      params[predefinedFacetsMap.ScreenResolution] = screenResolution;
      return this;
    },

    scriptValue: function (scriptValue) {
      params[predefinedFacetsMap.ScriptValue] = scriptValue;
      return this;
    },

    segment: function (segment) {
      params[predefinedFacetsMap.Segment] = segment;
      return this;
    },

    series: function (series) {
      params[predefinedFacetsMap.Series] = series;
      return this;
    },

    session: function (session) {
      params[predefinedFacetsMap.Session] = session;
      return this;
    },

    sampleRate: function (sampleRate) {
      params[predefinedFacetsMap.SampleRate] = sampleRate;
      return this;
    },

    source: function (source) {
      params[predefinedFacetsMap.Source] = source;
      return this;
    },

    scribeSDKVersion: function (scribeSDKVersion) {
      params[predefinedFacetsMap.ScribeSDKVersion] = scribeSDKVersion;
      return this;
    },

    developmentStage: function (developmentStage) {
      params[predefinedFacetsMap.DevelopmentStage] = developmentStage;
      return this;
    },

    build: function (build) {
      params[predefinedFacetsMap.Build] = build;
      return this;
    },

    stringValue: function (stringValue) {
      params[predefinedFacetsMap.StringValue] = stringValue;
      return this;
    },

    vehicleTypeID: function (vehicleTypeID) {
      params[predefinedFacetsMap.VehicleTypeID] = vehicleTypeID;
      return this;
    },

    tag: function (tag) {
      params[predefinedFacetsMap.Tag] = tag;
      return this;
    },

    token: function (token) {
      params[predefinedFacetsMap.Token] = token;
      return this;
    },

    telco: function (telco) {
      params[predefinedFacetsMap.Telco] = telco;
      return this;
    },

    timestamp: function (timestamp) {
      params[predefinedFacetsMap.Timestamp] = timestamp;
      return this;
    },

    timeIngested: function (timeIngested) {
      params[predefinedFacetsMap.TimeIngested] = timeIngested;
      return this;
    },

    timeIngestedKafka: function (timeIngestedKafka) {
      params[predefinedFacetsMap.TimeIngestedKafka] = timeIngestedKafka;
      return this;
    },

    timeConsumedKafka: function (timeConsumedKafka) {
      params[predefinedFacetsMap.TimeConsumedKafka] = timeConsumedKafka;
      return this;
    },

    eventType: function (eventType) {
      params[predefinedFacetsMap.EventType] = eventType;
      return this;
    },

    eventID: function (eventID) {
      params[predefinedFacetsMap.EventID] = eventID;
      return this;
    },

    value: function (value) {
      params[predefinedFacetsMap.Value] = value;
      return this;
    },

    dropoffLocation: function (dropoffLocation) {
      params[predefinedFacetsMap.DropoffLocation] = dropoffLocation;
      return this;
    },

    additionalDropLocations: function (additionalDropLocations) {
      params[
        predefinedFacetsMap.AdditionalDropLocations
      ] = additionalDropLocations;
      return this;
    },

    locationGeohash: function (locationGeohash) {
      params[predefinedFacetsMap.LocationGeohash] = locationGeohash;
      return this;
    },

    batch: function (batch) {
      params[predefinedFacetsMap.Batch] = batch;
      return this;
    },

    variantID: function (variantID) {
      params[predefinedFacetsMap.VariantID] = variantID;
      return this;
    },

    treatment: function (treatment) {
      params[predefinedFacetsMap.Treatment] = treatment;
      return this;
    },

    statsBatchID: function (statsBatchID) {
      params[predefinedFacetsMap.StatsBatchID] = statsBatchID;
      return this;
    },

    statsEventSource: function (statsEventSource) {
      params[predefinedFacetsMap.StatsEventSource] = statsEventSource;
      return this;
    },

    scribeSDKType: function (scribeSDKType) {
      params[predefinedFacetsMap.ScribeSDKType] = scribeSDKType;
      return this;
    },

    kudo: function (kudo) {
      params[predefinedFacetsMap.Kudo] = kudo;
      return this;
    },

    partnerID: function (partnerID) {
      params[predefinedFacetsMap.PartnerID] = partnerID;
      return this;
    },

    partitionKey: function (partitionKey) {
      params[predefinedFacetsMap.PartitionKey] = partitionKey;
      return this;
    },

    mexMerchant: function (mexMerchant) {
      params[predefinedFacetsMap.MexMerchant] = mexMerchant;
      return this;
    },

    browserType: function (browserType) {
      params[predefinedFacetsMap.BrowserType] = browserType;
      return this;
    },

    browserVersion: function (browserVersion) {
      params[predefinedFacetsMap.BrowserVersion] = browserVersion;
      return this;
    },

    pageTitle: function (pageTitle) {
      params[predefinedFacetsMap.PageTitle] = pageTitle;
      return this;
    },

    urlPath: function (urlPath) {
      params[predefinedFacetsMap.URLPath] = urlPath;
      return this;
    },

    pageLocation: function (pageLocation) {
      params[predefinedFacetsMap.PageLocation] = pageLocation;
      return this;
    },

    customFacet: function (k, v) {
      if (typeof k !== "string") throw Error("Facet key must be a string");
      params[k] = v;
      return this;
    },

    buildFacets: function () {
      if (Object.keys(params).length < 1)
        throw Error("Facet building failed: at least one facet is required");
      return new PredefinedFacets(params);
    },
  });
};

function PredefinedFacets(params) {
  Object.assign(this, params);
}

export { PredefinedFacetsBuilder };
